<template>
  <div :class="$style['input-bar']">
    <!-- 虚假输入框 -->
    <div :class="$style['input-field']" @click="handleOpenInput">
      {{ canComment == 1 ? '能不能上去就看你了~' : '该帖子不可评论哦~' }}
    </div>
    <div :class="$style.share" @click="handleShare">
      <img :src="share_icon" alt />
    </div>
    <div :class="$style.reply" @click="handleComment">
      <img :src="reply_icon" />
      <span>{{ detail.comment }}</span>
    </div>
    <div :class="$style['thumb-clicked']" @click.stop="handlePraise">
      <img :src="canThumbClicked ? like_icon : red_like_icon" />
      <span :style="{ color: !canThumbClicked ? '#fb7166' : '' }">{{ detail.support }}</span>
    </div>
  </div>
</template>

<script>
import { Popup } from "vant";
import { doPraise } from '@/api/gameCircle';
import { reportData } from '@/api/report';
import { CDN_URL } from "@/config/index.js";
import { wxShareData } from '@/utils/wxinit';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  components: {
    VanPopup: Popup
  },
  props: {
    isFirstReply: {
      type: Boolean,
      default: false
    },
    // 帖子或回复的楼主详细信息
    detail: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      share_icon: `${CDN_URL}/share.png`, // 分享按钮小图标
      like_icon: `${CDN_URL}/praise.png`, // 点赞小图标
      red_like_icon: `${CDN_URL}/red_praise.png`, // 红色点赞小图标
      reply_icon: `${CDN_URL}/chat.png`, // 回复小图标
      shareImage: `${window.location.protocol}${this.$cdnUrl}/share/share_icon.jpg`, // 分享图片
    };
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    ...mapState("gameCircle", {
      canComment: state => state.canComment // 帖子是否可评论 1：可评论； 2：不可评论
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false
      return flag;
    },
    // 游戏圈id
    circleId() {
      return this.$route.query.circleId
    },
    // 帖子id
    conversationId() {
      return this.$route.query.id
    },
    // 帖子是否可点赞
    canThumbClicked() {
      return this.detail.is_support == 1 ? false : true
    },
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHARE_MASK: 'CHANGE_SHARE_MASK',
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG'
    }),
    handleOpenInput() {
      reportData({
        type: 5,
        data_type: 5,
        circle_id: this.circleId,
        conversation_id: this.conversationId
      })
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true)
        return
      }
      if (this.canComment == 2) return
      this.$emit('openReplyField')
    },
    // 分享
    handleShare() {
      reportData({
        type: 5,
        data_type: 10,
        circle_id: this.circleId,
        conversation_id: this.conversationId
      })
      wxShareData()
      this.CHANGE_SHARE_MASK(true)
    },
    // 评论
    handleComment() {
      reportData({
        type: 5,
        data_type: 11,
        circle_id: this.circleId,
        conversation_id: this.conversationId
      })
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true)
        return
      }
      if (this.canComment == 2) return
      this.$emit('openReplyField')
    },
    // 帖子/回复点赞
    async handlePraise() {
      if (this.isFirstReply) {
        reportData({
          type: 5,
          data_type: 12,
          circle_id: this.circleId,
          conversation_id: this.conversationId
        })
      }
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true)
        return
      }
      if (this.detail.is_support) return;
      let data = {}
      // 如果是一级回复则传话题id:conversation_id, 如果是多级回复则传评论id: comment_id
      if (this.isFirstReply) {
        data = {
          conversation_id: this.conversationId
        }
      } else {
        data = {
          comment_id: this.detail.id
        }
      }
      const r = await doPraise(data)
      setTimeout(() => {
        this.$emit('refreshDetail')
      }, 10);
    }
  },
}
</script>

<style lang='scss' module>
.input-bar {
  position: absolute;
  bottom: 0;
  z-index: 41;
  width: 100%;
  height: 50px;
  padding: 9px 0px 15px 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 10px;
  font-weight: 400;
  background-color: white;
  .input-field {
    width: 212px;
    height: 30px;
    padding-left: 14px;
    display: inline-block;
    line-height: 30px;
    background: rgba(243, 244, 248, 1);
    border-radius: 16px;
    font-size: 13px;
    color: rgba(159, 159, 159, 1);
  }
  .share {
    margin-left: 15px;
    > img {
      width: 17px;
    }
  }
  .reply,
  .thumb-clicked {
    & > img {
      width: 17px;
      margin-right: 3px;
    }
    & > span {
      color: rgba(159, 159, 159, 1);
      position: relative;
      top: -3px;
    }
  }
  .thumb-clicked {
    margin-right: 5px;
  }
}
</style>
